(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["danfee-blog-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('danfee-blog-carousel')) {
  customElements.define('danfee-blog-carousel', class extends HTMLElement {
    async connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('ul');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      let nextPage = this.dataset.nextPage;
      const seenPages = new Set();
      try {
        while (nextPage && !seenPages.has(nextPage)) {
          seenPages.add(nextPage);
          const url = new URL(nextPage, location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal });
          if (!response.ok) throw new Error('Blog article loading failed');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const carousel = page.querySelector('danfee-blog-carousel');
          if (!carousel) throw new Error('Blog carousel missing from response');
          const existing = new Set(Array.from(this.track.children, item => item.querySelector('a')?.getAttribute('href')));
          for (const item of carousel.querySelector('ul').children) {
            const href = item.querySelector('a')?.getAttribute('href');
            if (!existing.has(href)) {
              const copy = item.cloneNode(true);
              copy.id = `Slide-${this.dataset.sectionId}-${this.track.children.length + 1}`;
              copy.classList.remove('scroll-trigger', 'animate--slide-in');
              this.track.append(copy);
              existing.add(href);
            }
          }
          nextPage = carousel.dataset.nextPage;
        }
      } catch (error) {
        if (signal.aborted) return;
        console.warn('Could not load remaining blog articles', error);
      }
      if (signal.aborted || !this.isConnected) return;
      this.originals = Array.from(this.track.children);
      this.count = this.originals.length;
      if (this.count < 2) {
        this.querySelector('.slider-buttons')?.setAttribute('hidden', '');
        return;
      }
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const duplicate = (item) => {
        const copy = item.cloneNode(true);
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        copy.classList.remove('scroll-trigger', 'animate--slide-in');
        copy.querySelectorAll('.scroll-trigger').forEach(node => node.classList.remove('scroll-trigger', 'animate--slide-in'));
        return copy;
      };
      this.before = this.originals.map(duplicate);
      this.after = this.originals.map(duplicate);
      this.track.prepend(...this.before);
      this.track.append(...this.after);
      this.items = Array.from(this.track.children);
      this.index = this.count;
      this.querySelector('.slider-counter--total').textContent = this.count;
      this.position = (index) => this.items[index].offsetLeft - this.items[0].offsetLeft;
      this.jump = (index) => {
        this.index = index;
        this.track.scrollTo({ left: this.position(index), behavior: 'instant' });
        this.update();
      };
      this.update = () => {
        this.querySelector('.slider-counter--current').textContent = (this.index % this.count) + 1;
        const viewport = this.track.getBoundingClientRect();
        this.items.forEach(item => {
          const rect = item.getBoundingClientRect();
          const visible = rect.right > viewport.left + 2 && rect.left < viewport.right - 2;
          item.inert = !visible;
          if (visible) item.removeAttribute('aria-hidden');
          else item.setAttribute('aria-hidden', 'true');
        });
      };
      this.settle = () => {
        if (this.dragging) return;
        const left = this.track.scrollLeft;
        this.index = this.items.reduce((best, item, i) =>
          Math.abs(this.position(i) - left) < Math.abs(this.position(best) - left) ? i : best, 0);
        if (this.index < this.count) this.jump(this.index + this.count);
        else if (this.index >= this.count * 2) this.jump(this.index - this.count);
        this.update();
        this.start();
      };
      this.stop = () => clearTimeout(this.timer);
      this.start = () => {
        this.stop();
        if (!this.visible || document.hidden || this.hovered || this.dragging ||
            this.contains(document.activeElement) || this.motion.matches) return;
        this.timer = setTimeout(() => this.move(1), 5000);
      };
      this.move = (direction) => {
        this.stop();
        this.index = Math.max(0, Math.min(this.items.length - 1, this.index + direction));
        this.track.scrollTo({ left: this.position(this.index), behavior: this.motion.matches ? 'instant' : 'smooth' });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(this.settle, 800);
      };
      this.querySelector('[name="previous"]').addEventListener('click', () => this.move(-1), { signal });
      this.querySelector('[name="next"]').addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => {
        this.stop();
        this.update();
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(this.settle, 180);
      }, { passive: true, signal });
      this.track.addEventListener('pointerdown', () => { this.dragging = true; this.stop(); }, { passive: true, signal });
      window.addEventListener('pointerup', () => { if (this.dragging) { this.dragging = false; this.settleTimer = setTimeout(this.settle, 180); } }, { signal });
      window.addEventListener('pointercancel', () => { this.dragging = false; this.start(); }, { signal });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.stop(); }, { signal });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.start(); }, { signal });
      this.addEventListener('focusin', this.stop, { signal });
      this.addEventListener('focusout', () => setTimeout(() => this.start(), 0), { signal });
      document.addEventListener('visibilitychange', () => this.start(), { signal });
      this.motion.addEventListener('change', () => this.start(), { signal });
      this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.start(); });
      this.observer.observe(this);
      this.resize = new ResizeObserver(() => { this.jump(this.index); this.start(); });
      this.resize.observe(this.track);
      requestAnimationFrame(() => this.jump(this.count));
    }
    disconnectedCallback() {
      this.stop?.();
      clearTimeout(this.settleTimer);
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      this.before?.forEach(item => item.remove());
      this.after?.forEach(item => item.remove());
      this.originals?.forEach(item => { item.inert = false; item.removeAttribute('aria-hidden'); });
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["danfee-duty-estimator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rates = {
      AT: { duty: 0.025, tax: 0.20 }, AU: { duty: 0.05, tax: 0.10 },
      BE: { duty: 0.025, tax: 0.21 }, CA: { duty: 0.065, tax: 0.05 },
      CH: { duty: 0, tax: 0.081 }, DE: { duty: 0.025, tax: 0.19 },
      DK: { duty: 0.025, tax: 0.25 }, ES: { duty: 0.025, tax: 0.21 },
      FI: { duty: 0.025, tax: 0.255 }, FR: { duty: 0.025, tax: 0.20 },
      GB: { duty: 0.025, tax: 0.20 }, HK: { duty: 0, tax: 0 },
      IE: { duty: 0.025, tax: 0.23 }, IT: { duty: 0.025, tax: 0.22 },
      JP: { duty: 0.052, tax: 0.10 }, KR: { duty: 0.08, tax: 0.10 },
      LU: { duty: 0.025, tax: 0.17 }, NL: { duty: 0.025, tax: 0.21 },
      NO: { duty: 0, tax: 0.25 }, NZ: { duty: 0.05, tax: 0.15 },
      PL: { duty: 0.025, tax: 0.23 }, PT: { duty: 0.025, tax: 0.23 },
      SE: { duty: 0.025, tax: 0.25 }, SG: { duty: 0, tax: 0.09 },
      TW: { duty: 0.05, tax: 0.05 }, AE: { duty: 0.05, tax: 0.05 },
      US: { duty: null, tax: null }
    };

    const formatPercent = (value) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'percent',
      maximumFractionDigits: 1
    }).format(value);

    const initialize = (root) => {
      if (root.dataset.dutyInitialized === 'true') return;
      root.dataset.dutyInitialized = 'true';

      const select = root.querySelector('[data-duty-country]');
      const selection = root.querySelector('[data-duty-selection]');
      const goods = root.querySelector('[data-duty-goods]');
      const dutyOutput = root.querySelector('[data-duty-duty]');
      const taxOutput = root.querySelector('[data-duty-tax]');
      const totalOutput = root.querySelector('[data-duty-total]');
      const rateOutput = root.querySelector('[data-duty-rate]');
      const unsupported = root.querySelector('[data-duty-unsupported]');
      const localizationForm = root.querySelector('.danfee-duty__localization-form');
      const countryInput = root.querySelector('[data-duty-country-input]');
      const variantData = root.querySelector('[data-duty-variants]');
      const variants = variantData ? JSON.parse(variantData.textContent) : [];
      const currency = root.dataset.currency || 'USD';
      const labels = {
        selected: root.dataset.labelSelected,
        rate: root.dataset.labelRate,
        unavailable: root.dataset.labelUnavailable
      };
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency
      });

      const getAmount = () => {
        if (root.dataset.context !== 'product') return Number(root.dataset.amount || 0) / 100;
        const selectedOptions = Array.from(document.querySelectorAll('select[data-option-name], input[data-option-name]:checked'))
          .map((input) => input.value);
        const optionVariant = selectedOptions.length
          ? variants.find((variant) => selectedOptions.every((value, index) => variant.options[index] === value))
          : null;
        if (optionVariant) return Number(optionVariant.price) / 100;
        const formVariant = document.querySelector('form[action*="/cart/add"] [name="id"]');
        const currentId = formVariant ? String(formVariant.value) : '';
        const currentVariant = variants.find((variant) => String(variant.id) === currentId);
        return Number(currentVariant ? currentVariant.price : root.dataset.amount || 0) / 100;
      };

      const render = () => {
        const code = select.value;
        const countryName = select.options[select.selectedIndex]?.textContent.trim() || code;
        const amount = getAmount();
        const rate = rates[code];

        selection.textContent = `${labels.selected}: ${countryName}`;
        goods.textContent = formatter.format(amount);

        if (!rate || rate.duty === null || rate.tax === null) {
          dutyOutput.textContent = labels.unavailable;
          taxOutput.textContent = labels.unavailable;
          totalOutput.textContent = formatter.format(amount);
          rateOutput.textContent = '';
          unsupported.hidden = false;
          return;
        }

        const duty = amount * rate.duty;
        const tax = (amount + duty) * rate.tax;
        const total = amount + duty + tax;
        dutyOutput.textContent = formatter.format(duty);
        taxOutput.textContent = formatter.format(tax);
        totalOutput.textContent = formatter.format(total);
        rateOutput.textContent = `${labels.rate} ${formatPercent(rate.duty)} · VAT/GST ${formatPercent(rate.tax)}`;
        unsupported.hidden = true;
      };

      const transitionRender = () => {
        if (document.startViewTransition) document.startViewTransition(render);
        else render();
      };

      select.addEventListener('change', () => {
        transitionRender();
        if (localizationForm && countryInput && select.value !== root.dataset.country) {
          countryInput.value = select.value;
          localizationForm.requestSubmit();
        }
      });
      document.addEventListener('change', (event) => {
        if (event.target.matches('form[action*="/cart/add"] [name="id"], select[data-option-name], input[data-option-name]')) {
          window.setTimeout(transitionRender, 0);
        }
      });
      render();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-duty-estimator]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
